import { useContext, useSyncExternalStore } from "react";
import { ReactReduxContext } from "react-redux";

const noStore = { subscribe: () => () => undefined, getState: () => ({}) };

type LockSlice = { billingEnabled?: boolean; hasActiveSubscription?: boolean; isTrialActive?: boolean; trialEndsAt?: unknown } | undefined;

/** The same lock rule as PrivateRoute: billing on, not staff, no plan, no running trial, and the trial has started (pre-trial is open). */
export const lockedOf = (billing: LockSlice, isSuperAdmin = false): boolean => {
  if (!billing || isSuperAdmin || !billing.billingEnabled) return false;
  const preTrial = (billing.trialEndsAt ?? null) === null && !billing.hasActiveSubscription;
  return !billing.hasActiveSubscription && !billing.isTrialActive && !preTrial;
};

/**
 * The account is locked (trial over, no plan). Its calls answer 402 on every page, so the frame stops asking for them
 * (project list, bell counts, notice choices); My settings and Billing still work. False where no store is mounted.
 */
export const useAccountLocked = (): boolean => {
  const store = useContext(ReactReduxContext)?.store ?? noStore;
  const read = () => {
    const st = store.getState() as { billingStore?: LockSlice; authStore?: { currentUser?: { role?: string } | null } };
    return lockedOf(st.billingStore, st.authStore?.currentUser?.role === "super_admin");
  };
  return useSyncExternalStore(store.subscribe, read, read);
};
